import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintcollege = () => {
  const title = "{BRAND.domainLabel} runs a focus group at Trinity College and Mansfield College Oxford with freshers and masters students understanding social media impact and views on {BRAND.short}."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on October, 2024</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                In October 2024, {BRAND.domainLabel} hosted a focus group with
                first-year and master&apos;s students at the University of
                Oxford, including participants from Trinity College and
                Mansfield College. The aim of the session was to explore current
                attitudes towards social media amongst students and the appetite
                for a new kind of social media offering. The students provided
                valuable feedback regarding the user interface of {BRAND.domainLabel},
                declaring it a “cleaner” and “calmer” online space. They also
                were highly interested in the charitable donations element of
                the platform, and saw it as a way to elevate all voices and
                raise awareness for important themes.
              </p>

              <p>
                Fresher students saw {BRAND.short} as a potential online “icebreaker”
                to seek new friendships and activities that would be aligned to
                their values, and thus feel less of a hurdle to navigate,
                especially since Fresher&apos;s Week may sometimes be
                overstimulating and overwhelming for some. Finalists on the
                other hand had their eye more towards the job market and
                suggested a {BRAND.content.singular} profile could be seen as an extension to
                their CV or LinkedIn, that would focus on finding employers that
                shared their values and purpose. Therefore, suggesting there was
                space in the social media market for a more ESG/impact aligned
                personal and professional platform offering.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintcollege;
